import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MCollapseComponent } from './collapse.component';

@NgModule({
  declarations: [MCollapseComponent],
  exports: [MCollapseComponent],
  imports: [CommonModule, NzOutletModule, NzIconModule]
})
export class MCollapseModule {}
